export const linkToCopy = (link: string) =>
  link.replace('https://', '').replace('http://', '');

export const getOriginUrl = (): string => {
  return document?.location?.origin;
};

export const buildLinkToCandidateAuth = (candidateCode = ''): string => {
  if (!candidateCode) {
    return '';
  }
  return `${getOriginUrl()}/s/${candidateCode}`;
};
